export enum SearchOption {
  TopDirectoryOnly = "TopDirectoryOnly",
  AllDirectories = "AllDirectories",
}
